const NAMESPACE = 'NEW_ROUTES';

const SET_NEW_ROUTE_LINKS = `${NAMESPACE}/SET_NEW_ROUTE_LINKS`;

export {
    SET_NEW_ROUTE_LINKS,
};

export default NAMESPACE;
